import type { Maybe, Model } from 'src/types';
import type { CurrentCampaign, RouteSection } from '../../types';

export interface IProductPageTabsProps extends IProductTabMainProps {
  routeSection: RouteSection;
}

export interface IProductTabMainProps {
  recommendations?: Maybe<Model[]>;
  currentCampaign: CurrentCampaign;
}

export enum TabAnchor {
  ALL = '#all',
  PROPERTIES = '#properties',
  REVIEWS = '#reviews',
  STATISTICS = '#statistics',
}
